import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=912d82e8&scoped=true&"
import script from "./Step1.vue?vue&type=script&lang=js&"
export * from "./Step1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912d82e8",
  null
  
)

export default component.exports